import { faRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useState } from 'react';
import VoxelIconButton from '../../../components/voxel/Buttons/VoxelIconButton';
import VoxelTable from '../../../components/voxel/Tables/VoxelTable';
import VoxelTableCell from '../../../components/voxel/Tables/VoxelTableCell';
import VoxelTableHeadCell from '../../../components/voxel/Tables/VoxelTableHeadCell';
import VoxelTablePaginationDataSpecific from '../../../components/voxel/Tables/VoxelTablePaginationDataSpecific';
import VoxelTableRow from '../../../components/voxel/Tables/VoxelTableRow';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import { PagingInputGq } from '../../../graphql/users/models/PagingInputGq';
import { PagingResultGq } from '../../../graphql/users/models/PagingResultGq';
import { usersApiService } from '../../../graphql/users/usersApiService';
import VoxelAvatar from '../../../components/voxel/VoxelAvatar';

export interface RemovedMembersTableProps {
  currentUser: CurrentUserGq;
  users: CurrentUserGq[];
  paging: PagingInputGq;
  pagingResult: PagingResultGq;
  setPaging: (paging: PagingInputGq) => void;
  reload: () => Promise<unknown>;
}

export const RemovedMembersTable: React.FC<RemovedMembersTableProps> = ({
  currentUser,
  users,
  paging,
  pagingResult,
  setPaging,
  reload,
}) => {
  const [loadingUserIds, setLoadingUserIds] = useState<number[]>([]);

  // Restore user mutation
  const restoreUserAcessMutation = usersApiService.mutations.useRestoreUserAccess();
  const restoreUser = (userId: number) => {
    setLoadingUserIds((prev) => [...prev, userId]);
    restoreUserAcessMutation({ userId: userId })
      .catch((errorReason) => console.error(errorReason))
      .then(reload)
      .finally(() => setLoadingUserIds((prev) => prev.filter((uid) => uid != userId)));
  };

  return (
    <>
      <VoxelTable>
        <thead>
          <VoxelTableRow>
            <VoxelTableHeadCell>Email</VoxelTableHeadCell>
            <VoxelTableHeadCell align="center">Removed by</VoxelTableHeadCell>
            <VoxelTableHeadCell align="center">Removed time</VoxelTableHeadCell>
            <VoxelTableCell />
          </VoxelTableRow>
        </thead>
        <tbody>
          {users.map((member) => (
            <VoxelTableRow key={member?.id}>
              <VoxelTableCell className="py-2.5 select-all">{member?.email}</VoxelTableCell>
              <VoxelTableCell align="center" className="py-2.5">
                <VoxelAvatar
                  name={member?.deletedBy?.email}
                  img={member?.deletedBy?.picture}
                  size='md'
                  tooltip={
                    <>
                      {member?.deletedBy?.givenName + ' ' + member?.deletedBy?.familyName}
                      <br />
                      {member?.deletedBy?.email}
                    </>
                  }
                />
              </VoxelTableCell>
              <VoxelTableCell align="center" className="py-2.5">
                {!member?.deletedTime
                  ? '-'
                  : moment.utc(member?.deletedTime).local().format('MMM Do, YY')}
              </VoxelTableCell>

              <VoxelTableCell align="right">
                <VoxelIconButton
                  tooltip="Restore user as a team member"
                  disabled={
                    !currentUser?.team?.accessUserCanEditMembersUpTo ||
                    loadingUserIds.includes(member.id)
                  }
                  onClick={() => restoreUser(member?.id)}
                  size="xs"
                  color="white"
                  icon={<FontAwesomeIcon icon={faRotateLeft} size="lg" />}
                />
              </VoxelTableCell>
            </VoxelTableRow>
          ))}
          <VoxelTablePaginationDataSpecific
            pagingInput={paging}
            onPagingChange={(event, x) => setPaging(x)}
            pagingResult={pagingResult}
            colSpan={6}
          />
        </tbody>
      </VoxelTable>
    </>
  );
};

export default RemovedMembersTable;
